import React, { useRef } from 'react';
import MuiButton from '@material-ui/core/Button';
import ArrowDownIcon from '@material-ui/icons/ArrowDropDown';
import styled from 'styled-components/macro';
import { getButtonStyle } from '../engine/CustomButtonWizardEngine';
import useTranslations from '../../hooks/useTranslations';
import {
  Divider as MuiDivider,
  Menu,
  MenuItem as MuiMenuItem
} from '@material-ui/core';
import Colors from '../../internal-components/Colors';

const Button = styled(MuiButton)`
  && {
    ${({ $fullPadding }) => !$fullPadding && 'padding: 0  0 0 12px;'}

    text-transform: none;
    ${({ $customCSS }) => $customCSS}
  }

  [class*='MuiButton-endIcon'] {
    margin-right: 0;
    span {
      display: flex;
      align-items: center;
    }
  }
`;

const MenuButton = styled(MuiButton)`
  && {
    min-width: 0;
    padding: 10px 0;
    border-radius: 0 4px 4px 0;
    svg {
      color: ${({ $color }) => $color};
    }
  }
`;

const MenuItem = styled(MuiMenuItem)`
  && {
      
    ${({ selected, $itemColor }) => {
      return `color: ${$itemColor} !important; ${
        selected
          ? `background: ${$itemColor} !important; !important; text-shadow: none !important;`
          : ''
      }`;
    }}
  }

  &:hover {
    transition: 0.25s;
     ${({ selected, $itemColor }) => {
       return `background: ${selected ? `${$itemColor}75` : `${$itemColor}2e`}
     !important;}`;
     }}
`;

const Divider = styled(MuiDivider)`
  && {
    background: ${({ $color }) => $color};
    height: 75%;
  }
`;

const MultipurposeButtonView = props => {
  const t = useTranslations();
  const btnRef = useRef(null);
  return (
    <>
      <Button
        id={props.id}
        data-id={props.id}
        ref={btnRef}
        variant="outlined"
        disableRipple={props.isMainButtonInactive}
        onClick={props.isMainButtonInactive ? () => {} : props.onClick}
        endIcon={
          props.options.length > 1 ? (
            <span
              onMouseOver={() => props.setIsMainButtonInactive(true)}
              onMouseLeave={() => props.setIsMainButtonInactive(false)}
            >
              <Divider
                orientation="vertical"
                $color={
                  props.variant === 'contained'
                    ? '#fff'
                    : props.color || Colors.PRIMARY
                }
              />
              <MenuButton
                onClick={e => props.setMenuAnchor(btnRef.current)}
                $color={
                  props.variant === 'contained'
                    ? '#fff'
                    : props.color || Colors.PRIMARY
                }
              >
                <ArrowDownIcon />
              </MenuButton>
            </span>
          ) : (
            undefined
          )
        }
        $fullPadding={props.options.length <= 1}
        $customCSS={`${getButtonStyle(
          props.variant || 'contained',
          props.color || Colors.PRIMARY
        )} ${props.customCSS}`}
        variant={props.variant}
        {...props.muiBtnProps}
      >
        {t(props.label)}
      </Button>

      <Menu
        anchorEl={props.menuAnchor}
        open={Boolean(props.menuAnchor)}
        onClose={() => props.setMenuAnchor(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        elevation={3}
        getContentAnchorEl={null}
      >
        {props.options.map(b => (
          <MenuItem
            $itemColor={b.color || Colors.PRIMARY}
            key={b.id}
            selected={b.id === props.id}
            onClick={() => props.onButtonChange(b.id)}
          >
            {t(b.label)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MultipurposeButtonView;
